var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioDit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "11.738px",
    height: "14px",
    viewBox: "0 0 11.738 14",
    enableBackground: "new 0 0 11.738 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#53B5E0",
    d: "M11.676,10.118c-0.342,1.062-1.373,1.745-2.484,1.647c-0.3-0.006-0.645,0.319-0.892,0.569 c-0.613,0.854-1.527,1.444-2.558,1.653c-1.312,0.089-2.612-0.291-3.669-1.073c-1.139-0.827-1.87-2.101-2.011-3.5 c-0.206-1.364,0.106-2.755,0.876-3.9c0.435-0.843,0.814-1.714,1.137-2.606c0.641-1.23,1.371-2.43,2.847-2.808 c0.406-0.1,1.035-0.191,1.265,0.027c0.875,0.828,1.993,0.327,2.911,0.7c0.384,0.195,0.7,0.502,0.908,0.88 c0.37,0.643,0.694,1.311,0.969,2c0.069,0.164-0.064,0.4-0.073,0.611c-0.032,0.784-0.067,1.568-0.066,2.352 c0.02,0.242,0.081,0.479,0.183,0.7c0.227,0.6,0.508,1.179,0.688,1.79C11.746,9.479,11.737,9.803,11.676,10.118z M6.788,2.743 c-1.794,0.493-3.63,2.776-3.06,3.936c0.118-0.213,0.22-0.362,0.289-0.525c0.43-1.014,1.216-1.835,2.211-2.308 C6.676,3.72,6.936,3.256,6.81,2.81C6.804,2.787,6.796,2.765,6.788,2.743z M9.299,4.173c0.33-0.979,0.158-1.5-0.528-1.807 C8.623,2.3,8.376,2.403,8.199,2.482C8.127,2.573,8.105,2.693,8.137,2.804c0.319,0.275,0.662,0.521,1.128,0.875L9.299,4.173z  M2.335,10.516c0.039-0.559,0.608-1.188-0.286-1.541C1.604,9.544,1.651,9.827,2.335,10.516z M4.207,11.716l1.625-0.5l-0.09-0.3 c-0.408,0.473-1.247-0.514-1.535,0.797V11.716z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioDit);
export default __webpack_public_path__ + "static/media/radio-dit.b39a95ba9a9e16a0112a08010ec02ed4.svg";
export { ForwardRef as ReactComponent };